export default function LogoMark({ className = "h-10 w-auto", tone = "#2C241E", dot = "#B3A18C" }) {
  return (
    <svg viewBox="0 0 64 88" className={className} fill="none" aria-hidden="true">
      <circle cx="32" cy="6" r="2.4" fill={tone} />
      <circle cx="32" cy="17" r="2.4" fill={tone} />
      <circle cx="27" cy="45" r="16" stroke={tone} strokeWidth="2.6" />
      <path d="M 49 31.1 A 16 16 0 1 0 49 58.9" stroke={tone} strokeWidth="2.6" strokeLinecap="round" />
      <circle cx="32" cy="71" r="2.4" fill={dot} />
      <circle cx="32" cy="82" r="2.4" fill={tone} />
    </svg>
  );
}
